import agent, { prepareHeaders } from 'api/agent';
import {
    OrderItemStatusChangeModel,
    OrderUpdateModel,
    EmptyOrderModel,
    StornoOrderItemModel,
} from 'api/models';
import axios from 'axios';

export const Order = {
    GetOrdersList: (
        searchString: string = '',
        dateFrom: string | undefined = undefined,
        dateTo: string | undefined = undefined,
        page: number,
        limit: number,
        asc: boolean,
        orderBy: string,
        position?: string,
        showClosed?: boolean
    ) =>
        agent.requests.get(
            `/Order/list?searchString=${searchString}&dateFrom=${dateFrom ?? ''}&dateTo=${
                dateTo ?? ''
            }&page=${page}&limit=${limit}&asc=${asc}&orderBy=${orderBy}&position=${position}&showClosed=${!!showClosed}`
        ),
    ChangeOrderItemStatus: (id: string, model: OrderItemStatusChangeModel) =>
        agent.requests.post(`/Order/${id}/changeitemstatus`, model),
    UpdateOrder: (id: string, model: OrderUpdateModel) =>
        agent.requests.post(`/Order/${id}`, model),
    GetOrder: (id: string) => agent.requests.get(`/Order/${id}`),
    GetNewOrdersCount: (position: string) =>
        agent.requests.get(`/Order/getneworderscount?position=${position}`),
    GetPositionOrders: (position: string) =>
        agent.requests.get(`/Order/getpositionorders?position=${position}`),
    CreateEmptyOrder: (model: EmptyOrderModel) =>
        agent.requests.put('/Order/createempty', model, prepareHeaders()),
    GetReadyDishes: (searchString: string = '', page: number, limit: number) =>
        agent.requests.get(
            `/Order/getreadydishes?searchString=${searchString}&page=${page}&limit=${limit}`
        ),
    GetOverdudedOrders: () => agent.requests.get(`Order/getoverdudedorders`),
    GetOverdudedOrdersDetails: (ordersNumbers: number[]) =>
        agent.requests.get(
            `Order/getoverdudedordersdetails?${ordersNumbers
                .map((x) => 'orderNumber=' + x)
                .join('&')}`
        ),
    AssignOrder: (orderId: string, restaurantId: string, userId: string) =>
        agent.requests.post(`/Order/${orderId}/assign`, {
            restaurantId: restaurantId,
            userId: userId,
        }),
    SetOrderPriceLevel: (orderId: string, priceLevelId: string) =>
        agent.requests.post(`/Order/${orderId}/priceLevel/`, {
            id: priceLevelId,
        }),
    DeliverItems: (orderId: string, itemsUniqueIds: string[]) =>
        agent.requests.post(`/Order/${orderId}/delivery-items`, { ids: itemsUniqueIds }),
    PrintOrder: (
        orderId: string,
        itemsUniqueIds?: string[],
        dailyMenuId?: string,
        status?: string
    ) => {
        const params = new URLSearchParams();
        if (itemsUniqueIds) {
            params.append('itemsIds', itemsUniqueIds.join(','));
        }
        if (status) {
            params.append('status', status);
        }
        if (dailyMenuId) {
            params.append('dailyMenuId', dailyMenuId);
        }
        return axios
            .get(`/Order/${orderId}/print`, {
                params,
                ...prepareHeaders(),
                responseType: 'blob',
            })
            .then(({ data }) => {
                const blobUrl = window.URL.createObjectURL(
                    new Blob([data], { type: 'application/pdf' })
                );
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = blobUrl;

                iframe.onload = function () {
                    setTimeout(() => {
                        if (iframe.contentWindow) {
                            iframe.contentWindow.focus();
                        }
                        if (iframe.contentWindow) {
                            iframe.contentWindow.print();
                        }
                        URL.revokeObjectURL(blobUrl);
                    }, 100);
                };

                document.body.appendChild(iframe);
            });
    },
    PrintMultipleOrders: (
        orderIds?: string[],
        status?: string,
        workAreas?: string[],
        position?: string
    ) => {
        const params = new URLSearchParams();
        if (orderIds && orderIds.length > 0) {
            params.append('orders', orderIds.join(','));
        }
        if (status) {
            params.append('status', status);
        }
        if (workAreas && workAreas.length > 0) {
            params.append('workAreas', workAreas.join(','));
        }
        if (position) {
            params.append('position', position);
        }

        return axios
            .get(`/Order/print`, {
                params,
                ...prepareHeaders(),
                responseType: 'blob',
            })
            .then(({ data }) => {
                const blobUrl = window.URL.createObjectURL(
                    new Blob([data], { type: 'application/pdf' })
                );
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = blobUrl;

                iframe.onload = function () {
                    setTimeout(() => {
                        if (iframe.contentWindow) {
                            iframe.contentWindow.focus();
                        }
                        if (iframe.contentWindow) {
                            iframe.contentWindow.print();
                        }
                        URL.revokeObjectURL(blobUrl);
                    }, 100);
                };

                document.body.appendChild(iframe);
            });
    },
    UpdateOrderService: (id: string, service: string) =>
        agent.requests.post(`/Order/${id}/service`, {
            service,
        }),
    StornoOrderItems: (orderId: string, items: StornoOrderItemModel[]) =>
        agent.requests.post(`/Order/${orderId}/storno-items`, items),
};
